import { hexToRgb } from '../utils/color-utils';
import { objectFromEntries } from '../utils/types-utils';
const hexColors = require('../assets/styles/utils/palette.scss');

const rgbMap = Object
    .entries(hexColors)
    .map(
        ([paletteName, paletteValue]) => [
            paletteName,
            hexToRgb(paletteValue)
        ]
    );

const rgbArrayColors = objectFromEntries(rgbMap);

const rgbColors = objectFromEntries(
    rgbMap.map(
            ([paletteName, paletteValue]) => [
                paletteName,
                paletteValue.join(', ')
            ]
        )
    );

export {
    hexColors,
    rgbArrayColors,
    rgbColors
}